import { NestedComponentStyleOverrides } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';
import { weakMapMemoize } from '@reduxjs/toolkit';

/**
 * Merges two mappings of selectors to nested override definitions
 * together so that styles and the style classes defined at each selector
 * are merged together, the SECOND overwriting any values in the FIRST one.
 * @param overrides1 1st mapping of nested overrides
 * @param overrides2 2nd mapping of nested overrides
 * @returns merged mapping of nested overrides
 */
const mergeNestedComponentStyleOverrides = weakMapMemoize(
  (
    overrides1: NestedComponentStyleOverrides | null | undefined,
    overrides2: NestedComponentStyleOverrides | null | undefined,
  ): NestedComponentStyleOverrides => {
    if (!overrides1 || !overrides2) {
      return overrides2 || overrides1 || {};
    }
    return Object.entries(overrides2).reduce((result, [nestedSelector, nestedOverride2]) => {
      const nestedOverride1 = result[nestedSelector];
      return {
        ...result,
        [nestedSelector]: { ...nestedOverride1, ...nestedOverride2 },
      };
    }, overrides1);
  },
);

export default mergeNestedComponentStyleOverrides;
